export default __webpack_public_path__ + "02ffd39c1da6a31436391d2061cc9429.png";